import {
  getUploadedTinReport,
  userTinList,
  getUploadedTinList,
  getTinUsageReport,
} from "./api";
import { Dashboard,XTable,useState, useEffect,Pagination  } from "./import";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";

const TinUploadReport = () => {
  const [userReport, setUserReport] = useState([]);
  const [modal, setModal] = useState(false);
  const [tinReport, setTinReport] = useState([]);
  const [current, setCurrent] = useState(1);
  const [userId,setUserId]=useState("")

  const onChange = (page) => {
    setCurrent(page);
    getUploadedTinList(userId,page).then((res)=>{
      setTinReport(res.data)
    })
  };

  const toggle = () => setModal(!modal);
  useEffect(() => {
    getUploadedTinReport().then((res) => {
      setUserReport(res.data.status);
    });
  }, []);

  const onClickView = (id) => {
    
    setUserId(id)
    getUploadedTinList(id, 1).then((res) => {
      toggle();
      setTinReport(res.data);
    });
  };

  return (
    <Dashboard title={"Tin Uploaded Report"}>
        <div className="border">
          <XTable
            columns={[
              "User_Name",
              "User_Email",
              "User_Role",
              "Total_TIN_Used",
              "Action",
            ]}
            rows={userReport?.map((ele) => {
              return {
                User_Name: ele?.User_Name,
                User_Email: ele?.User_Email,
                User_Role: ele?.User_Role,
                Total_TIN_Used: ele?.total,
                Action: (
                  <div style={{ display: "flex" }}>
                    <button
                      size="sm"
                      type="primary"
                      className="btn-sm btn-primary"
                      // onClick={() => {
                      //   handleEdit(ele._id);
                      // }}
                      // id={ele?._id}
                      onClick={() => onClickView(ele?._id)}
                    >
                      <i class="fa fa-edit"></i> View
                    </button>
                  </div>
                ),
              };
            })}
          />
        </div>
      <Modal size="xl" isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Uploaded TIN List</ModalHeader>
        <ModalBody>
          <div className="card-body row p-3 border mb-2 bg-white cursor-pointer shadow-sm ">
            <table className="table bg-white ">
              <thead>
                <tr>
                  <th>Upload User Name</th>
                  <th>TIN No</th>
                  <th>TIN TYPE</th>
                  <th>TIN Status</th>
                
                </tr>
              </thead>
              <tbody>
                {tinReport?.tinList?.map((ele) => {
                  return (
                    <tr>
                      <td>{ele?.uploadUserId?.name}</td>
                      <td>{ele?.tinNo}</td>
                      <td>{ele?.tinType}</td>
                      <td>{ele?.tinStatus ? "Active" : "inActive"}</td>
                    
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <Pagination current={current} onChange={onChange} total={tinReport?.getTinListCount} />
          </div>
        </ModalBody>
        <ModalFooter></ModalFooter>
      </Modal>
    </Dashboard>
  );
};

export default TinUploadReport;
